import React from 'react'
import './App.scss'
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Card,
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTruckLoading,
  faEuroSign,
  faFileSignature,
  faPhone,
  faEnvelope,
  faHourglass,
  faUserClock,
  faMapMarkedAlt,
  faSync,
  faCarCrash,
  faLocationArrow,
} from '@fortawesome/free-solid-svg-icons'

export default function App() {
  return (
    <>
      <Navbar bg="light" expand="lg" sticky="top">
        <Container>
          <Navbar.Brand href="/">
            <img
              alt=""
              src="/assets/logo.png"
              height="45"
              className="d-inline-block align-top"
            />
          </Navbar.Brand>
          {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
          {/* <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto" />
          </Navbar.Collapse> */}
          <Nav>
            <Nav.Link href="mailto:info@zalgirio-pastoliai.lt">
              <FontAwesomeIcon
                icon={faEnvelope}
                color="primary"
              />
              info@zalgirio-pastoliai.lt
            </Nav.Link>
            <Nav.Link href="tel:+37067755447">
              <FontAwesomeIcon icon={faPhone} />
              +37067755447
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      <Container>
        <Tips />
        <Contact />
        <div className="container mb-4">
          <iframe
            title="map"
            src="https://maps.google.com/maps?q=klev%C5%B3%20g.%2011%2C%20avi%C5%BEieniai&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="380"
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </Container>
      <Navbar
        bg="primary"
        variant="dark"
        fixed="bottom"
        className="text-center"
      >
        &copy; 2019 <strong> UAB "Sanigis"</strong>
      </Navbar>
    </>
  )
}

function Contact() {
  return (
    <Row>
      {[
        [
          'Adresas',
          ['Klevų g. 11, Avižienių k., 14192 Vilniaus r.'],
          faLocationArrow,
        ],
        [
          'Kontaktinis telefonas',
          ['+37067755447', 'Sandėlis Tomas +37067062789'],
          faPhone,
        ],
        [
          'El. paštas',
          ['info@zalgirio-pastoliai.lt'],
          faEnvelope,
        ],
      ].map(([title, text, icon], i, arr) => {
        return (
          <Col
            key={i}
            sm={12}
            md={12 / arr.length}
            className="text-center"
          >
            <Card.Body>
              <FontAwesomeIcon
                icon={icon}
                color="primary"
              />
              <Card.Title>{title}</Card.Title>
              {text.length ? (
                text.map(t => (
                  <Card.Text key={t}>{t}</Card.Text>
                ))
              ) : (
                <Card.Text>{text}</Card.Text>
              )}
            </Card.Body>
          </Col>
        )
      })}
    </Row>
  )
}

function Tips() {
  return (
    <Row>
      {[
        {
          title: 'Fasadiniai pastoliai',
          tips: ['LAYHER Blitz'],
          src: 'assets/fasadiniu-pastoliu-nuoma-2.jpg',
          text: `LAYHER Blitz`,
        },
        {
          title: 'Moduliniai pastoliai',
          tips: [''],
          src: 'assets/moduliniai-pastoliai.jpg',
          text: `LAYHER Allround`,
        },
        {
          title: 'Aliuminio bokšteliai',
          tips: [''],
          src: 'assets/aliuminio-pastoliai.jpg',
          text: `Patogus montavimas`,
        },
        {
          title: 'Pastolių montavimas',
          tips: [''],
          src: 'assets/pastoliu-montavimas.jpg',
          text: `Pristatome ir sumontuojame`,
        },
      ].map(({ src, title, text }, i) => {
        return (
          <Col key={i} sm={12} md={6} lg={3}>
            <Card
              bg="dark"
              text="white"
              border="light"
              className="mb-4"
            >
              <Card.Img src={src} alt={title} />
              <Card.Body>
                <Card.Title>{title}</Card.Title>
                <Card.Text>{text}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        )
      })}
    </Row>
  )
}
